

































import { createComponent } from "@vue/composition-api";
import { productGroupResource } from "@megarax/client/src/resources/plm";
import { produktResource } from "@megarax/client/src/resources/plm/Produkt";
import ResourceTableColumn from "@/components/ResourceTableColumn.vue";
import ResourceItemTable from "@/components/resource/ResourceItemTable.vue";

export default createComponent({
  components: {
    ResourceTableColumn,
    ResourceItemTable,
  },
  setup(props, ctx) {
    return {
      resource: produktResource,
      productGroupResource,
    };
  },
});
